import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import Modal from '#app/View/ClientService/OrderClientLitige/components/Modal';

type Props = {
  reload: () => void;
  onClose: () => void;
  carrierPrice: number;
};

const RefundShippingModal: React.FC<Props> = ({ onClose, reload, carrierPrice }) => {
  const params = useParams<{ uuid: string }>();
  const uuid = params.uuid as string;
  const [loading, setLoading] = useState<boolean>(false);

  const [form, setForm] = useState<Form>({
    carrierPrice: {
      name: 'carrierPrice',
      label: 'Montant TTC du transport',
      textHelper: 'Remboursement du montant TTC du transport.',
      type: 'float',
      defaultValue: carrierPrice,
      options: { max: carrierPrice, validation: ['required'] },
    },
  });
  const handler = initFormHandler(form, setForm);

  useEffect(() => {
    handler.start();
  }, []);

  const handleSubmit = () => {
    if (handler.checkError() > 0) {
      return;
    }
    setLoading(true);

    const data = handler.getData();
    ApiHandler.post(
      {
        route: 'api_client_service_order_client_litige_refund_shipping',
        params: { uuid },
        data: { carrierPrice: data.carrierPrice },
      },
      (response) => {
        if (response.status === 200) {
          dispatch(
            SnackbarOpen({
              text: 'Demande de remboursement créée avec succès.',
              variant: 'success',
            }),
          );
          reload();
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }
        setLoading(false);
        onClose();
      },
    );
  };

  return (
    <Modal title="Remboursement" onClose={onClose} onSubmit={handleSubmit} loading={loading}>
      <TextFieldComponent id="carrierPrice" handler={handler} />
    </Modal>
  );
};

export default RefundShippingModal;
